import React from "react";
import { useState } from "react";

const imagePaths = {empty: 'img/empty.jpg', full: 'img/full.jpg'};

export function WaterBar(props) {
    let cups = [];
    for (let i = 0; i < parseInt(props.target); i++) {
        cups.push(<WaterCup key={i}/>);
    }
    return (
        <div className="d-flex text-center waterTracker">
            {cups}
        </div>
    );
}

function WaterCup() {
    const[imgSrc, setImgSrc] = useState(imagePaths.empty);
    const [isEmpty, setIsEmpty] = useState(true);
    let handleClick = () => {
        if (isEmpty) {
            setImgSrc(imagePaths.full);
            setIsEmpty(false);
        } else {
            setImgSrc(imagePaths.empty);
            setIsEmpty(true);
        }
    }
    return (
        <div>
            <img src={imgSrc} alt="empty cup" className="m-auto emptyCup" onClick={handleClick}/>
        </div>
    )
}